import { makeStyles } from '@material-ui/core';

export const sharedStyles = {
  root: {
    marginLeft: '1em',
  },
};
export default makeStyles(() => sharedStyles);
